(function (window) {
  'use strict';

  /**
   * Globe geometry is locked. Only light color / bloom intensity change here.
   */
  function globeSvg(modeId) {
    var id = modeId === 'cw' ? 'cw' : 'rgb';
    var isCw = modeId === 'cw';
    var cx = 100;
    var cy = 108;
    var r = 78;
    var seamY = cy - r + 1.76 * r;
    var sphere = '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '"';
    var light = isCw ? '#ffffff' : 'var(--lamp-glass, hsl(var(--lamp-hue) 62% 52%))';

    return (
      '<svg class="umbrella-configurator__lamp-draw lamp-rig lamp-rig--' +
      id +
      '" viewBox="0 0 200 250" aria-hidden="true">' +
      '<defs>' +
      '<clipPath id="lamp-sphere-' +
      id +
      '">' +
      sphere +
      '/></clipPath>' +
      '<clipPath id="lamp-glass-clip-' +
      id +
      '"><rect x="0" y="0" width="200" height="' +
      seamY +
      '"/></clipPath>' +
      '<clipPath id="lamp-cap-clip-' +
      id +
      '"><rect x="0" y="' +
      seamY +
      '" width="200" height="80"/></clipPath>' +
      '<radialGradient id="lamp-glass-fill-' +
      id +
      '" cx="48%" cy="38%" r="72%">' +
      (isCw
        ? '<stop offset="0%" stop-color="#ffffff"/>' +
          '<stop offset="42%" stop-color="#ffffff"/>' +
          '<stop offset="78%" stop-color="#e8eef4"/>' +
          '<stop offset="100%" stop-color="#c5ced8"/>'
        : '<stop offset="0%" stop-color="var(--lamp-glass, hsl(var(--lamp-hue) 56% 64%))"/>' +
          '<stop offset="42%" stop-color="var(--lamp-glass, hsl(var(--lamp-hue) 66% 50%))"/>' +
          '<stop offset="78%" stop-color="var(--lamp-glass, hsl(var(--lamp-hue) 70% 38%))"/>' +
          '<stop offset="100%" stop-color="var(--lamp-glass, hsl(var(--lamp-hue) 62% 24%))"/>') +
      '</radialGradient>' +
      '<radialGradient id="lamp-core-' +
      id +
      '" cx="50%" cy="42%" r="48%">' +
      (isCw
        ? '<stop offset="0%" stop-color="#ffffff" stop-opacity="1"/>' +
          '<stop offset="50%" stop-color="#ffffff" stop-opacity="0.42"/>' +
          '<stop offset="100%" stop-color="#ffffff" stop-opacity="0"/>'
        : '<stop offset="0%" stop-color="var(--lamp-glass, hsl(var(--lamp-hue) 52% 56%))" stop-opacity="0.72"/>' +
          '<stop offset="50%" stop-color="var(--lamp-glass, hsl(var(--lamp-hue) 68% 40%))" stop-opacity="0.28"/>' +
          '<stop offset="100%" stop-color="var(--lamp-glass, hsl(var(--lamp-hue) 70% 28%))" stop-opacity="0"/>') +
      '</radialGradient>' +
      '<linearGradient id="lamp-metal-' +
      id +
      '" x1="30%" y1="0%" x2="70%" y2="100%">' +
      '<stop offset="0%" stop-color="#3a2e24"/>' +
      '<stop offset="28%" stop-color="#1a1410"/>' +
      '<stop offset="62%" stop-color="#0c0a09"/>' +
      '<stop offset="100%" stop-color="#050403"/>' +
      '</linearGradient>' +
      '<linearGradient id="lamp-metal-spill-' +
      id +
      '" x1="50%" y1="0%" x2="50%" y2="100%">' +
      '<stop offset="0%" stop-color="' +
      light +
      '" stop-opacity="0.22"/>' +
      '<stop offset="40%" stop-color="#000" stop-opacity="0"/>' +
      '</linearGradient>' +
      '</defs>' +
      '<g class="lamp-body" clip-path="url(#lamp-sphere-' +
      id +
      ')">' +
      '<g clip-path="url(#lamp-glass-clip-' +
      id +
      ')">' +
      sphere +
      ' class="lamp-glass-shell" fill="url(#lamp-glass-fill-' +
      id +
      ')"/>' +
      '<circle class="lamp-glass-core" cx="' +
      cx +
      '" cy="' +
      (cy - 6) +
      '" r="44" fill="url(#lamp-core-' +
      id +
      ')"/>' +
      (isCw
        ? '<rect class="lamp-breathe-veil" x="0" y="0" width="200" height="' +
          seamY +
          '" fill="#050505"/>'
        : '<rect class="lamp-color-wash lamp-hue-fill" x="0" y="0" width="200" height="' +
          seamY +
          '" fill="var(--lamp-glass, hsl(var(--lamp-hue) 72% 46%))"/>' +
          '<rect class="lamp-dim-veil" x="0" y="0" width="200" height="' +
          seamY +
          '" fill="#050505"/>') +
      '</g>' +
      '<g clip-path="url(#lamp-cap-clip-' +
      id +
      ')">' +
      sphere +
      ' class="lamp-metal" fill="url(#lamp-metal-' +
      id +
      ')"/>' +
      '<rect x="0" y="' +
      seamY +
      '" width="200" height="18" fill="url(#lamp-metal-spill-' +
      id +
      ')"/>' +
      '</g>' +
      '</g>' +
      '<ellipse class="lamp-contact-soft" cx="' +
      cx +
      '" cy="' +
      (cy + r + 6) +
      '" rx="52" ry="8" fill="#000" fill-opacity="0.28"/>' +
      '<ellipse class="lamp-contact" cx="' +
      cx +
      '" cy="' +
      (cy + r + 3) +
      '" rx="28" ry="4" fill="#000" fill-opacity="0.55"/>' +
      '</svg>'
    );
  }

  window.LeavesLampCard = {
    markup: function (modeId) {
      var isBasic = modeId === 'cw';
      var title = isBasic ? 'Basic<br>model' : 'Vibrant<br>color';
      return (
        '<span class="umbrella-configurator__lamp-title">' +
        title +
        '</span>' +
        '<span class="umbrella-configurator__lamp-room lamp-room--' +
        (isBasic ? 'cw' : 'rgb') +
        '">' +
        '<span class="umbrella-configurator__lamp-wall-light"></span>' +
        '<span class="umbrella-configurator__lamp-floor-shadow"></span>' +
        '<span class="umbrella-configurator__lamp-floor-light"></span>' +
        '<span class="umbrella-configurator__lamp-floor-spec"></span>' +
        (isBasic ? '' : '<span class="umbrella-configurator__lamp-cct-veil" aria-hidden="true"></span>') +
        '<span class="umbrella-configurator__lamp-orbit">' +
        globeSvg(modeId) +
        '</span>' +
        '</span>' +
        (isBasic
          ? '<span class="umbrella-configurator__lamp-legend lamp-legend--level">Dim</span>' +
            '<span class="umbrella-configurator__lamp-strip lamp-strip--level" data-lamp-strip="level" role="slider" aria-label="Brightness" aria-valuemin="0" aria-valuemax="100" aria-valuenow="50">' +
            '<span class="umbrella-configurator__lamp-strip-thumb" aria-hidden="true"></span>' +
            '</span>'
          : '<span class="umbrella-configurator__lamp-legend lamp-legend--hue">RGBCW</span>' +
            '<span class="umbrella-configurator__lamp-legend lamp-legend--level">Dim</span>' +
            '<span class="umbrella-configurator__lamp-strip lamp-strip--hue" data-lamp-strip="hue" role="slider" aria-label="RGBCW" aria-valuemin="0" aria-valuemax="100" aria-valuenow="50">' +
            '<span class="umbrella-configurator__lamp-strip-mark" aria-hidden="true"></span>' +
            '<span class="umbrella-configurator__lamp-cw-label lamp-cw-label--c" aria-hidden="true">C</span>' +
            '<span class="umbrella-configurator__lamp-cw-label lamp-cw-label--w" aria-hidden="true">W</span>' +
            '<span class="umbrella-configurator__lamp-strip-thumb" aria-hidden="true"></span>' +
            '</span>' +
            '<span class="umbrella-configurator__lamp-strip lamp-strip--level" data-lamp-strip="level" role="slider" aria-label="Brightness" aria-valuemin="0" aria-valuemax="100" aria-valuenow="50">' +
            '<span class="umbrella-configurator__lamp-strip-thumb" aria-hidden="true"></span>' +
            '</span>') +
        '<span class="umbrella-configurator__lamp-guard" data-lamp-guard></span>'
      );
    },
  };
})(window);
